module.exports = __webpack_public_path__ + "static/img/guidance11.90b41afc.png";